import React from "react";
import { Link } from "react-router-dom";

export default function SuplierDash() {
  return (
    <div className="p-6">

      <div className="grid grid-cols-2 md:grid-cols-3 gap-4">

        <Link to="/Home" className="bg-indigo-600 text-white p-4 rounded">Home</Link>

        <Link to="/MNGMT/Search/Produto" className="bg-blue-600 text-white p-4 rounded">Produtos</Link>

        <Link to="/MNGMT/Profile/" className="bg-green-600 text-white p-4 rounded">Perfil</Link>

        <Link to="/MNGMT/Business/Vendas" className="bg-yellow-600 text-white p-4 rounded">Vendidos</Link>

        <Link to="/MNGMT/Order/Produto" className="bg-orange-600 text-white p-4 rounded">Pedidos </Link>

        <Link to="/MNGMT/Order/Produto/2day" className="bg-red-600 text-white p-4 rounded">Novos Pedidos</Link>

        <Link to="/MNGMT/Ads/Produto" className="bg-purple-600 text-white p-4 rounded">Pedidos de Marketing</Link>

      </div>
    </div>
  );
}